// import React from "react";
// import clients from "../../data/clients";

// const ClientLogos = () => {
//   return (
//     <section className="py-16 bg-white">
//       <div className="container mx-auto px-4">
//         <div className="text-center mb-12">
//           <h2 className="text-3xl font-bold text-gray-800">
//             Our Trusted Clients
//           </h2>
//           <div className="w-24 h-1 bg-blue-600 mx-auto mt-4"></div>
//         </div>

//         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 items-center justify-items-center">
//           {clients.map((client, index) => (
//             // <div key={index} className="flex items-center justify-center p-4 h-24">
//             //   <img
//             //     src={client.img}
//             //     alt={`${client.name} Logo`}
//             //     style={{
//             //       maxHeight: client.height || 'auto',
//             //       maxWidth: client.maxWidth || '100%'
//             //     }}
//             //     className="object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
//             //   />
//             // </div>
//             <div
//               key={index}
//               className="flex items-center justify-center p-4 h-24"
//               onMouseEnter={(e) => {
//                 e.currentTarget.querySelector("img").style.filter = "none";
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.querySelector("img").style.filter =
//                   "grayscale(100%)";
//               }}
//             >
//               <img
//                 src={client.img}
//                 alt={`${client.name} Logo`}
//                 style={{
//                   maxHeight: client.height || "auto",
//                   maxWidth: client.maxWidth || "100%",
//                   filter: "grayscale(100%)",
//                   transition: "filter 0.3s",
//                 }}
//                 className="object-contain"
//               />
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ClientLogos;

import React from "react";
import clients from "../../data/clients";

const ClientLogos = () => {
  const allClients = [...clients, ...clients]; // Duplicate for seamless loop

  return (
    <section className="py-16 bg-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 font-heading">
            Our Trusted Clients
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mt-4"></div>
        </div>

        <div className="logo-marquee">
          <div className="logo-track">
            {allClients.map((client, index) => (
              <div className="logo-item" key={index}>
                <img
                  src={client.img}
                  alt={`${client.name} Logo`}
                  style={{
                    maxHeight: client.height || "60px",
                    maxWidth: client.maxWidth || "120px",
                    // filter: "grayscale(100%)",
                    // transition: "filter 0.3s",
                  }}
                  // onMouseEnter={(e) =>
                  //   (e.currentTarget.style.filter = "none")
                  // }
                  // onMouseLeave={(e) =>
                  //   (e.currentTarget.style.filter = "grayscale(100%)")
                  // }
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
